var map = {
	"./virtual_background_blur.jpg": "./src/assets/images/virtual-background/virtual_background_blur.jpg",
	"./virtual_background_inside_01.jpg": "./src/assets/images/virtual-background/virtual_background_inside_01.jpg",
	"./virtual_background_inside_02.jpg": "./src/assets/images/virtual-background/virtual_background_inside_02.jpg",
	"./virtual_background_inside_03.jpg": "./src/assets/images/virtual-background/virtual_background_inside_03.jpg",
	"./virtual_background_inside_04.jpg": "./src/assets/images/virtual-background/virtual_background_inside_04.jpg",
	"./virtual_background_outside_01.jpg": "./src/assets/images/virtual-background/virtual_background_outside_01.jpg",
	"./virtual_background_outside_02.jpg": "./src/assets/images/virtual-background/virtual_background_outside_02.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/virtual-background sync recursive ^\\.\\/virtual_background_.*\\.jpg$";